import initApp from "@dinahmoe/dmafjs-core/src/bootstrap.js";

import workspace from "../../workspace.json";
import setupApplication from "../../src/index.js";

async function run() {
  const packages = Object.keys(workspace.packages)
    .filter((name) => name !== "dmafjs-core" && name.startsWith("dmafjs-"))
    .map((name) => import(`../../../packages/${name}/src/index.js`));
  await Promise.all(packages);

  await setupApplication();
  initApp();
}

run();
